const initialState = {
    isPending: false,
    items: []
};

const redeemHistory = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_HISTORY_PENDING_STATE':
            return {
                ...state,
                isPending: action.payload,
            };
        case 'UPDATE_HISTORY_ITEMS':
            return {
                ...state,
                items: action.payload,
            };
        default:
            return state;
    }
};

export default redeemHistory;